import { cn } from '@/lib/utils';

interface GlobalBenefitsBadgeProps {
  hasGlobalBenefits?: boolean;
  className?: string;
}

export function GlobalBenefitsBadge({ hasGlobalBenefits, className }: GlobalBenefitsBadgeProps) {
  if (!hasGlobalBenefits) return null;

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center justify-center rounded-full border px-3 py-1 text-xs font-medium',
        'border-blue-200 bg-blue-50 text-blue-700',
        className,
      )}
      data-testid="global-benefits-badge"
    >
      International Benefits
    </span>
  );
}
